module.exports = __webpack_public_path__ + "img/hosting_thumbnail-400x300.70a8a296.jpg";